import { Col, Row } from "antd";
import { GradientButton } from "components/GradientButton";
import { FC } from "react";
import AnimatedProject from "./components/AnimatedProject";
import styles from "./styles.module.css";

const RebakedProject: FC = () => {
  return (
    <div className={styles.root}>
      <div className="container-lg">
        <Row>
          <Col xs={24} md={14} lg={12}>
            <img
              className={styles.decorator}
              src="/images/landing/rectangle_2.png"
              alt="rect"
            />
            <div className={styles.content}>
              <h1>Do More With ReBaked</h1>
              <p>
                CrowdHack is a part of ReBaked portfolio of products. Go Beyond
                Hackathon with Build Pioneers and Playshare
              </p>
            </div>
            <a
              href="https://www.rebaked.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GradientButton>reBaked projects</GradientButton>
            </a>
          </Col>
          <Col className="f-end" xs={24} md={10} lg={12}>
            <AnimatedProject />
            {/* <img
              className={styles.image}
              src="/images/landing/rebaked_project.png"
            /> */}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default RebakedProject;
